import * as React from "react";
import { VBToolService } from "../service/vb-tool-service";
import { ActiveYearsModel } from "../domain/ActiveYearsModel";
import { useUnmounted } from "@shared/common";

export interface IProefBerekeningContext {
  activeYears: ActiveYearsModel;
}

const defaultActiveYears = new ActiveYearsModel([]);

const ProefBerekeningContext = React.createContext<IProefBerekeningContext>({
  activeYears: defaultActiveYears
});

export const useProefBerekeningContext = (): IProefBerekeningContext => {
  const context = React.useContext(ProefBerekeningContext);

  if (context === undefined) {
    throw new Error("useProefBerekeningContext must be used within a ProefBerekeningProvider");
  }

  return context;
};

export interface IProefBerekeningProviderProps {
  apiUrl: string;
}

type IProefBerekeningProvider = React.FunctionComponent<
  React.PropsWithChildren<IProefBerekeningProviderProps>
>;
export const ProefBerekeningProvider: IProefBerekeningProvider = (props) => {
  const [activeYears, setActiveYears] = React.useState(defaultActiveYears);
  const { getIsUnmounted } = useUnmounted();

  React.useEffect(() => {
    new VBToolService(props.apiUrl)
      .getActiveYears()
      .then((years) => {
        if (years && !getIsUnmounted()) {
          setActiveYears(years);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <ProefBerekeningContext.Provider value={{ activeYears }}>
      {props.children}
    </ProefBerekeningContext.Provider>
  );
};
